<template>
  <div>
    <div id="note" class="small-text mb-4">
      提醒完成線上報名後，仍需要下載簡章中的報名表格，依照表格說明，檢附各項資料跟作品集等，在規定期限內送交報名單位，才算完成報名。此報名系統僅作為線上登記之用。
      <br />
      離開此頁後請重新登入。
    </div>
    <form @submit.prevent="" ref="formRef">
      <div class="h4-style form-title">申請組別</div>
      <div class="row apply-row">
        <div class="col-12 col-md-6 col-lg-4">
          <Multiselect
            id="group"
            :options="groupOption"
            :required="true"
            placeholder="申請組別"
            v-model="postForm.group"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <Multiselect
            id="applyMethod"
            :options="applyMethodOption"
            :required="true"
            placeholder="申請管道"
            v-model="postForm.method"
          />
        </div>
      </div>
      <div class="h4-style form-title">基本資料</div>
      <div class="row apply-row">
        <div class="col-12 col-md-6 col-lg-4">
          <input
            type="text"
            required
            class="form-control"
            placeholder="姓名/中文"
            v-model="postForm.name"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <input
            type="text"
            required
            class="form-control"
            placeholder="姓名/英文(與護照相符)"
            v-model="postForm.name_en"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <input
            type="text"
            required
            class="form-control"
            placeholder="身分證字號"
            v-model="postForm.idno"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <Multiselect
            id="sex"
            v-model="postForm.gender"
            :options="sexOption"
            :required="true"
            placeholder="性別"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <Datepicker
            class="form-control"
            placeholder="出生日期"
            :typeable="true"
            required
            v-model="postForm.birthday"
          />
        </div>
      </div>
      <div class="h4-style form-title">就讀學校</div>
      <div class="row apply-row">
        <div class="col-12 col-md-6 col-lg-4">
          <input
            type="text"
            required
            class="form-control"
            placeholder="學校"
            v-model="postForm.school"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <input
            type="text"
            required
            class="form-control"
            placeholder="系所"
            v-model="postForm.dept"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <Multiselect
            id="schoolSystem"
            v-model="postForm.school_system"
            :options="schoolSystemOption"
            :required="true"
            placeholder="學制"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <input
            type="text"
            required
            class="form-control"
            placeholder="年級"
            v-model="postForm.grade"
          />
        </div>
      </div>
      <div class="h4-style form-title">聯絡方式</div>
      <div class="row apply-row">
        <div class="col-12 col-md-6 col-lg-4">
          <input
            type="text"
            required
            class="form-control"
            placeholder="行動電話"
            v-model="postForm.mobile"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <input
            type="text"
            required
            class="form-control"
            placeholder="電子郵件"
            v-model="postForm.email"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <input
            type="text"
            required
            class="form-control"
            placeholder="緊急聯絡人電話"
            v-model="postForm.emergency_contact_number"
          />
        </div>
        <div class="col-12 col-md-6">
          <input
            type="text"
            required
            class="form-control"
            placeholder="戶籍地址"
            v-model="postForm.addr"
          />
        </div>
        <div class="col-12 col-md-6">
          <input
            type="text"
            required
            class="form-control"
            placeholder="通訊地址"
            v-model="postForm.addr2"
          />
        </div>
      </div>
      <button id="send-btn" class="btn" @click="handleSubmit">送出資料</button>
      <div class="alert alert-info mt-3" role="alert" v-if="showAlert">
        {{ alertText }}
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import Datepicker from 'vue3-datepicker';
// import { ref } from 'vue';
import { createApplicant, updateApplicant } from '@/api/applicant';

// const applyForm = {
//   id: undefined,
//   group: 1,
//   method: 1,
//   name: 'ABV',
//   name_en: 'ACV',
//   idno: 'A153',
//   gender: 1,
//   birthday: new Date(),
//   school: 'AA',
//   dept: 'AA',
//   school_system: 1,
//   grade: '4',
//   addr: 'AA',
//   email: 'asasaas@gaqmoc.com',
//   addr2: 'AA',
//   mobile: '0945645555',
//   emergency_contact_number: '0915548988',
//   created_at: new Date(),
//   updated_at: new Date(),
// };
const applyForm = {
  id: undefined,
  group: 0,
  method: 0,
  name: '',
  name_en: '',
  idno: '',
  gender: 0,
  birthday: undefined,
  school: '',
  dept: '',
  school_system: 0,
  grade: '',
  addr: '',
  email: '',
  addr2: '',
  mobile: '',
  emergency_contact_number: '',
  created_at: new Date(),
  updated_at: new Date(),
};

export default {
  name: 'Apply',
  components: {
    Multiselect,
    Datepicker,
  },
  data() {
    return {
      isEdit: false,
      showAlert: false,
      alertText: '',
      postForm: { ...applyForm },
      groupOption: {
        1: '數位動畫組',
        2: '視覺傳達設計組',
        3: '時尚設計組',
      },
      applyMethodOption: {
        1: '自行申請',
        2: '學校推薦',
        3: '新一代金點新秀獎',
      },
      sexOption: {
        1: '男',
        2: '女',
      },
      schoolSystemOption: {
        1: '大學',
        2: '研究所',
      },
    };
  },
  created() {
    if (this.$route.name === 'Apply') {
      if (localStorage.applicantInfo) {
        this.isEdit = true;
        this.postForm = JSON.parse(localStorage.applicantInfo);
        this.postForm.birthday = new Date(this.postForm.birthday);
        // getApplicant(this.$route.params.applicantId)
        // .then(() => {
        // this.loading = false;
        // this.$message({
        //   message: '已發佈',
        //   type: 'success',
        // });
        // });
      } else {
        this.$router.push('/apply-login');
      }
    }
  },
  unmounted() {
    localStorage.removeItem('applicantInfo');
  },
  methods: {
    validate() {
      const form = this.$refs.formRef;
      return form.reportValidity();
    },
    handleSubmit(e) {
      // this.showAlert = false;
      this.alertText = '傳送中';
      this.postForm.gender = +this.postForm.gender;
      this.postForm.school_system = +this.postForm.school_system;
      this.postForm.group = +this.postForm.group;
      this.postForm.method = +this.postForm.method;
      e.preventDefault();
      if (this.validate()) {
        if (this.isEdit) {
          console.log('update');

          this.postForm.updated_at = new Date();
          updateApplicant(this.postForm)
            .then(() => {
              localStorage.setItem('applicantInfo', JSON.stringify(this.postForm));
              // alert('已更新資訊');
              this.showAlert = true;
              this.alertText = '已更新報名資訊';
            })
            .catch((err) => {
              console.log(err);
              this.showAlert = true;
              this.alertText = '發生錯誤，請稍後再試';
            });
        } else {
          console.log('new');
          createApplicant(this.postForm)
            .then(() => {
              localStorage.setItem('applicantInfo', JSON.stringify(this.postForm));
              this.isEdit = true;
              // alert('已上傳報名資訊');
              this.showAlert = true;
              this.alertText = '已上傳報名資訊';
            })
            .catch((err) => {
              console.log(err);
              this.showAlert = true;
              this.alertText = '發生錯誤，請稍後再試';
            });
        }
      }
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style lang="stylus" scoped>
.form-title
  margin-bottom: 20px;

.row
  > div
    margin-bottom: 30px;

  + .form-title
    margin-top: 10px;

::placeholder, :-ms-input-placeholder, ::-ms-input-placeholder
  color: $monoc2;
  opacity: 1;
  font-size: 15px;
  line-height: 150%;

#send-btn
  padding: 10px;
  color: $contract1;
  background: $monoc4;
  border-radius: 100px;

.alert-info
  border: none;
  background-color: $contract1;
  color: $monoc4;
</style>
<style lang="stylus">
.apply-row
  .multiselect
    line-height: 100%;

  .multiselect-clear
    background: none;

  .multiselect-input
    border-radius: 30px;
    border: 1px solid #463F3A;
    padding: 5px 10px;

  .multiselect-option.is-selected
    background: $monoc3;

  input.form-control
    padding: 10px 0 0;
    border: none;
    background: none;
    border-radius: 0;
    border-bottom: 1px solid #463F3A;

    &:focus, &:hover, &:active
      box-shadow: none;
</style>
